import type { ReactNode } from 'react';
import { IconBadge, type IconBadgeProps } from '@monksflow/monks-ui';

interface FormSectionProps {
  children?: ReactNode;
  icon: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  headerAction?: ReactNode;
  badgeVariant?: IconBadgeProps['variant'];
}

/**
 * The content indent (`pl-14`, 56px) is the badge width plus the header gap, so
 * the children line up with the title rather than with the badge.
 */
export function FormSection(props: FormSectionProps) {
  const { icon, title, description, headerAction, children, badgeVariant = 'muted' } = props;

  return (
    <div>
      <div className="flex items-center gap-4">
        <IconBadge variant={badgeVariant} size="default">
          {icon}
        </IconBadge>
        <div className="min-w-0 flex-1">
          <p className="text-base font-medium leading-6 text-foreground">{title}</p>
          {description !== undefined && description !== null && (
            <p className="text-sm text-muted-foreground">{description}</p>
          )}
        </div>
        {headerAction}
      </div>
      <div className="mt-6 pl-14">{children}</div>
    </div>
  );
}
